import Select, { SingleValue } from "react-select";
import { useSnapshot } from "valtio";
import { clientDashboardEvents, TreeNode } from "../clientDashboardEvents";
import { treeForStatus } from "../campaignDates";

type Option = { label: string; value: number | null };

const ALL_OPTION: Option = { label: "All Engagements", value: null };

export default function EngagementSelect() {
    const snap = useSnapshot(clientDashboardEvents);
    // Only engagements with a campaign of the selected status: offering one without hands the
    // user a zeroed dashboard on the next click (PO review).
    const tree = treeForStatus(snap.filterTree as TreeNode[], snap.status);

    if (!tree.length) return null;

    const options: Option[] = [ALL_OPTION, ...tree.map((e) => ({ label: e.name, value: e.id }))];
    const selected = options.find((o) => o.value === snap.engagement) ?? ALL_OPTION;

    return (
        <div className="dash-filter">
            <Select<Option, false>
                options={options}
                value={selected}
                onChange={(opt: SingleValue<Option>) => {
                    clientDashboardEvents.triggerEngagementChanged(opt?.value ?? null);
                }}
                menuPlacement="bottom"
                isClearable={false}
            />
        </div>
    );
}
